import Image from 'next/image';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface IEmptyScreen
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  description: string | React.ReactElement;
  addNew?: React.ReactElement;
}

const EmptyScreen: React.FC<IEmptyScreen> = ({
  description,
  addNew,
  ...props
}) => {
  return (
    <div
      {...props}
      className={twMerge(
        'flex w-full flex-col items-center justify-center gap-6 pt-10',
        props.className
      )}
    >
      <div className="col-span-2 flex justify-center">
        <Image
          width={232}
          height={89}
          src={`/img/group-empty.png`}
          alt="group-empty"
        />
      </div>
      <div className="text-center text-sm text-light_grey">{description}</div>
      {addNew && addNew}
    </div>
  );
};

export default EmptyScreen;
